import { Link, useLocation } from "react-router-dom";
import Logo from "./logo";


const DISPLAY_FONT = "'Anton', 'Oswald', 'Arial Narrow', sans-serif";

export default function Header({ refresh }) {
  // const [lastUpdated, setLastUpdated] = useState(null);
  // const [refreshing, setRefreshing] = useState(false);
  const { pathname } = useLocation();
  const onMarkets = pathname.startsWith("/collection");
 
  // const handleRefresh = async () => {
  //   if (!refresh) return;
 
  //   setRefreshing(true);
  //   try {
  //     await refresh();
  //     setLastUpdated(new Date());
  //   } catch (err) {
  //     console.error("Refresh failed:", err);
  //   } finally {
  //     setRefreshing(false);
  //   }
  // };

  return (
    <header className="sticky top-0 z-50 h-12 border-b-2 border-[#D0182B] bg-[#0A0A0A]">
      <div className="mx-auto flex h-full max-w-6xl items-center justify-between px-2 md:px-0">
        <div className="flex items-center gap-3">
          <Link to="/" className="flex items-center gap-1 md:gap-3">
            <Logo size="200" type="full" />

            {/* <span
              style={{ fontFamily: DISPLAY_FONT }}
              className="md:text-lg text-sm uppercase tracking-wide text-[#EDEAE1]"
            >
              On Point Combat
            </span> */}
          </Link>

          {/* <Link
            to="/collection"
            style={{ fontFamily: DISPLAY_FONT }}
            className={`hidden md:block border md:px-2 md:py-0.5 p-1 text-[11px] uppercase transition-all ease-in-out duration-300 ${
              onMarkets
                ? "border-[#D0182B] bg-[#D0182B] text-[#EDEAE1] font-semibold"
                : "border-[#D0182B] text-[#D0182B] font-semibold hover:bg-[#D0182B] hover:text-[#EDEAE1] hover:font-semibold"
            }`}
          >
            Official Fighter Collabs
          </Link> */}
        </div>

        <div className="flex items-center">
        <Link
            to="/collection"
            style={{ fontFamily: DISPLAY_FONT }}
            className={` border md:px-2 md:py-0.5 p-1 text-[11px] uppercase transitionAll ${
              onMarkets
                ? "border-[#D0182B] bg-[#D0182B] text-[#EDEAE1] font-semibold"
                : "border-[#D0182B] text-[#D0182B] font-semibold hover:bg-[#D0182B] hover:text-[#EDEAE1] hover:font-semibold"
            }`}
          >
            Official Fighter Collabs
          </Link>
          {/* {lastUpdated && (
            <span className="hidden text-[#8C8880] sm:block">
              {refreshing ? (
                <span className="flex items-center gap-1.5 text-[11px] uppercase tracking-wide">
                  <span className="spin inline-block border-t-[1.5px] border-[#D0182B]" />
                  Updating
                </span>
              ) : (
                <span className="font-sans text-[11px] font-normal">
                  Updated{" "}
                  <span className="font-nums font-bold text-[#EDEAE1]">
                    {lastUpdated.toLocaleTimeString()}
                  </span>
                </span>
              )}
            </span>
          )} */}

          {/* <button
            className="group flex h-7 w-7 items-center justify-center border border-[#2A2A2A] bg-transparent transition-all ease-in-out duration-300 hover:border-[#D0182B] hover:bg-[#D0182B]"
            onClick={handleRefresh}
          >
            <span className="flex items-center justify-center text-[#D0182B] group-hover:text-[#0A0A0A]">
              <span
                className={`block transition-all ease-in-out duration-300 ${
                  refreshing ? "animate-spin" : ""
                }`}
              >
                <ImSpinner11 size={12} />
              </span>
            </span>
          </button> */}
        </div>
      </div>
    </header>
  );
}